import { useState } from "react";
import Markdown from "react-markdown";
import type { Doc, Report } from "../types";
import { shortTime } from "../format";

export default function DocsView({ docs, reports }: { docs: Doc[]; reports: Report[] }) {
  const items: { name: string; markdown: string; meta?: string }[] = [
    ...docs.map((d) => ({ name: d.name, markdown: d.markdown })),
    ...reports.map((r) => ({
      name: `${r.kind} report — ${r.account_id ?? "all"} (${shortTime(r.created_at)})`,
      markdown: r.body_md,
      meta: r.verdict ?? undefined,
    })),
  ];
  const [active, setActive] = useState(0);

  if (items.length === 0) return <p className="muted">No documents or reports yet.</p>;

  return (
    <div className="docs">
      <nav aria-label="Documents" className="docs-nav">
        <ul>
          {items.map((it, i) => (
            <li key={it.name}>
              <button
                className={i === active ? "doc-link active" : "doc-link"}
                aria-current={i === active ? "page" : undefined}
                onClick={() => setActive(i)}
              >
                {it.name}
                {it.meta && <span className="doc-meta"> · {it.meta}</span>}
              </button>
            </li>
          ))}
        </ul>
      </nav>
      <article className="doc-body markdown" aria-label={items[active].name}>
        <Markdown>{items[active].markdown}</Markdown>
      </article>
    </div>
  );
}
